import { render } from "./overdue.vue?vue&type=template&id=641b7450&scoped=true"
import script from "./overdue.vue?vue&type=script&lang=js"
export * from "./overdue.vue?vue&type=script&lang=js"

import "./overdue.vue?vue&type=style&index=0&id=641b7450&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641b7450"]])

export default __exports__